
export default function FooterSection() {
  return (
    <footer id="contact" className="bg-[#0B1F3A] py-20">
      <div className="max-w-[1280px] mx-auto px-8 lg:px-20">
        <div className="flex items-start justify-between mb-16">
          <div>
            <p className="text-sm uppercase text-white/50 tracking-widest mb-4">
              SCALE NORTH SOLUTIONS
            </p>
            <p className="text-lg text-white/65 max-w-[380px] mb-3">
              Turning advanced technology into measurable growth.
            </p>
            <p className="text-sm text-white/40">
              Compliance-ready. Performance-focused. Built to scale.
            </p>
          </div>
          <div>
            <p className="text-[13px] uppercase text-white/40 mb-3">Contact</p>
            <a
              href="mailto:contact@scalenorthsolutions.com"
              className="text-lg text-[#1EB6B0] hover:text-[#1EB6B0]/80 transition-colors cursor-pointer"
            >
              contact@scalenorthsolutions.com
            </a>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6">
          <p className="text-[13px] text-white/35">
            &copy; 2026 Scale North Solutions. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
